<template>

</template>

<script>
export default {
    name: "LikeDefaultLayout"
}
</script>

<style scoped>

</style>